import { ParticipationStatus as ParticipationStatusModel } from '@models/Event'
import { useAppSelector } from '@store/hooks'
import { selectParticipationStatusById } from '@store/membership/ParticipationStatusReducer'
import { SBIcon } from '@supplement-bacon/react-toolkit/components'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Tag } from 'antd'
import { FC } from 'react'

type Props = SBModelComponent<ParticipationStatusModel> & {}

const ParticipationStatusTag: FC<Props> = ({ id, model }) => {
  const item = model
    ? model
    : useAppSelector(selectParticipationStatusById(id!))

  if (!item) {
    return <></>
  }

  return (
    <Tag color={item.color} icon={<SBIcon name={item.icon} />}>
      {item.name}
    </Tag>
  )
}

type ParticipationStatusTagType = {
  Tag: typeof ParticipationStatusTag
}

export { ParticipationStatusTag, type ParticipationStatusTagType }
